import StyledTableHead from 'Components/StyledTableHead'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import type { FC } from 'react'
import { t } from 'ttag'

const BenefitPaymentInfo: FC = () => {
  return (
    <>
      <StyledTableHead>
        <TableRow>
          <TableCell colSpan={3}>{t`Payment info (Benefit)`}</TableCell>
        </TableRow>
      </StyledTableHead>
      <TableBody>
        <TableRow>
          <TableCell>{t`No payment events available. (The order is paid with benefits)`}</TableCell>
        </TableRow>
      </TableBody>
    </>
  )
}

export { BenefitPaymentInfo }
